// extracted by mini-css-extract-plugin
module.exports = {"textBox":"textBox___2QAO9"};